import { render, staticRenderFns } from "./upmarker.vue?vue&type=template&id=d0539e82&scoped=true"
import script from "./upmarker.vue?vue&type=script&lang=js"
export * from "./upmarker.vue?vue&type=script&lang=js"
import style0 from "./upmarker.vue?vue&type=style&index=0&id=d0539e82&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d0539e82",
  null
  
)

export default component.exports